export default __webpack_public_path__ + "static/media/mailIcon.79f1a6b4.svg";